export type FlowConfig = {
  routes: string[];
  connectWalletRoute?: string;
};

export const issuanceFlow: FlowConfig = {
  routes: ['/status'],
  connectWalletRoute: '/',
};

export const flowConfigs: FlowConfig[] = [issuanceFlow];
